<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="relative the-nav-bar">

    <div class="vx-navbar-wrapper"
         ref="wrapper"
         :class="classObj">

      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

<!--        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->
        <span
          v-if="!isSpecial"
          class="page-title">{{pageTitle}}</span>
        <vs-spacer />
<!--        <search-bar />-->

<!--        <notification-drop-down />-->

        <profile-drop-down />

      </vs-navbar>

    </div>
    <tags-view
      :rapper-with="rapperWith"
    ></tags-view>
    <!--              MAM 主账户需要另外显示的逻辑, 需要显示 mt4别名没有别名就显示login 以及tag标签, MAM主-->
<!--    <div

      class="router-header flex flex-wrap items-center mb-6"
    >

    </div>-->
  </div>
</template>


<script>
import tagsView from "@/layouts/components/TagsView";
import { colorRgba } from '@/utils/index.js';
import { mapGetters } from 'vuex'
import Bookmarks            from "./components/Bookmarks.vue"
import SearchBar            from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown      from "./components/ProfileDropDown.vue"

export default {
  name: "the-navbar-vertical",
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    tagsView,
  },
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      rapperWith: '',
    }
  },
  watch: {
    '$route'(val){

    },
  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.assien)
  },
  computed: {
    ...mapGetters(['language','themeColor','realMobile']),
    themeOpacty(){
      return {
        background: colorRgba(this.themeColor,0.1),
        color: this.themeColor,
      }
    },
    isSpecial(){
      return this.$route.path.includes('mamMasterDetails') || this.$route.path.includes('mamSubDetails');
    },
    pageTitle(){
      return this.$route.meta.title;
    },
    navbarColorLocal() {
      return this.$store.getters.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.getters.verticalNavMenuWidth
    },
    textColor() {
      return {'text-white': (this.navbarColor != '#10163a' && this.$store.getters.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.getters.theme !== 'dark')}
    },
    windowWidth() {
      return this.$store.getters.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default")      return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth)              return "navbar-full"
    },
  },
  mounted(){
    this.assien();
  },
  methods: {
    assien(){
      this.rapperWith = this.$refs.wrapper.offsetWidth;
      console.log(this.rapperWith);
    },
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    }
  }
}
</script>
<style lang="scss" scoped>
  .page-title,
  .alias {
    font-size: 14px;
    color: #5E5873;
    font-weight: bold;
  }
</style>
